// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__5_UxB","inputDescription":"styles_inputDescription__3Tw3F"};